import { createResourceStore } from './createResourceStore';

const useTemplateStore = createResourceStore({
  endpoint: '/admin/templates',
  collectionKey: 'templates',
  itemKey: 'template',
  hasFetchById: true,
  extraState: { template: null },
  methods: {
    fetch: 'fetchTemplates',
    create: 'createTemplate',
    update: 'updateTemplate',
    delete: 'deleteTemplate',
    fetchById: 'fetchTemplateById',
  },
});

export default useTemplateStore;
